<template>
    <v-container class="report-body ma-0 pb-4">
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" md="4">
                        Relatório de Emissores
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4" class="text-right">
                        <v-tooltip bottom color="primary">
                            <template v-slot:activator="{ on }" >
                                <v-btn
                                    v-on="on"
                                    color="white"
                                    :loading="awaitingReportDownload"
                                    @click="exportReport()"
                                >
                                    <v-icon color="primary">mdi-download</v-icon>
                                </v-btn>
                            </template>
                            Baixar Relatório em XLS
                        </v-tooltip>
                        <v-btn
                            width="50%"
                            color="#f2c037"
                            class="filter-btn"
                            @click="filterDrawer = !filterDrawer"
                        >
                            <v-icon class="mr-2" small>mdi-filter-outline</v-icon>
                            Filtros {{filteredResult ? '(ativo)' : ''}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <emitter-report-table
                    ref="emitterReportTable"
                />
            </v-card-text>
        </v-card>
        <filter-drawer
            :show-drawer="filterDrawer"
            @clear-filter="clearFilter()"
            @apply-filter="applyFilter()"
        >
            <template v-slot:form>
                <v-form @submit.prevent="applyFilter()">
                    <v-row>
                        <v-col cols="12" md="12">
                            <p class="mb-2 filter-label">Nome do Emissor</p>
                            <v-text-field
                                v-model="filterEmitterName"
                                outlined
                                hide-details
                                append-icon="mdi-account"
                            />
                        </v-col>
                    </v-row>
                    <p class="mt-6 mb-2 filter-label">Reservas Finalizadas Em</p>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterEmittedStartDate"
                                        label="De"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="emittedStartDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                left
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterEmittedUntilDate"
                                        label="Até"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="emittedUntilDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </filter-drawer>
    </v-container>
</template>

<script>
import FilterDrawer from "../../components/Reports/FilterDrawer.vue";
import EmitterReportTable from "../../components/Reports/Tables/EmitterReportTable.vue";
import {downloadFile, getFileNameWithSalt} from "../../services/DownloadFileService";

export default {
    name: "EmittersReport",

    components: {
        EmitterReportTable,
        FilterDrawer,
    },

    data: () => ({
        filter: {},
        filterDrawer: '',
        filterEmitterName: '',
        filterEmittedStartDate: '',
        filterEmittedUntilDate: '',
        emittedStartDateCalendar: '',
        emittedUntilDateCalendar: '',
        filteredResult: '',
        awaitingReportDownload: false,
    }),

    methods: {
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },

        formatDateToFilter(date) {
            let formattedDate = '';
            if (date) {
                let dateSplit = date.split('/');
                if (dateSplit[2] && dateSplit[1]) {
                    formattedDate = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`
                    return formattedDate;
                }
            }
            return date;
        },

        clearFilter() {
            this.$router.replace({query: null});
            window.location.reload();
        },

        setFilter() {
            this.filter = {
                'emitterName': this.filterEmitterName ?? '',
                'emittedStartDate': this.formatDateToFilter(this.filterEmittedStartDate) ?? '',
                'emittedUntilDate': this.formatDateToFilter(this.filterEmittedUntilDate) ?? '',
            }
            this.filteredResult = this.resultIsFiltered(this.filter);
            this.$refs.emitterReportTable.setFilter(this.filter);
        },

        applyFilter() {
            this.setFilter();
            this.$refs.emitterReportTable.getReportData(this.filter);
            this.filterDrawer = !this.filterDrawer;
        },

        resultIsFiltered(filter) {
            for (let filterKey in filter) {
                if (filter[filterKey]) {
                    return true;
                }
            }
            return false;
        },

        getFilterFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    emitterName,
                    emittedStartDate,
                    emittedUntilDate,
                    startDate,
                    finalDate,
                } = this.$route.query;
                if (emitterName) {
                    this.filterEmitterName = emitterName;
                }
                if (emittedStartDate || startDate) {
                    this.filterEmittedStartDate = emittedStartDate ?? startDate;
                }
                if (emittedUntilDate || finalDate) {
                    this.filterEmittedUntilDate = emittedUntilDate ?? finalDate;
                }
            }
            this.setFilter();
        },

        async exportReport () {
            try {
                this.awaitingReportDownload = true;
                const response = await axios.get('/api/reports/emitter/export', { params: this.getQueryParams(), responseType: 'blob' });
                downloadFile(response.data, getFileNameWithSalt('relatorio_emissores_partner_hub'), 'xls');
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao baixar o relatório!', 'error');
            } finally {
                this.awaitingReportDownload = false;
            }
        },

        getQueryParams () {
            return {
                sortBy: this.getParamFromQuery('sortBy'),
                sortDesc: this.getParamFromQuery('sortDesc'),
                limit: this.getParamFromQuery('limit'),
                emitterName: this.filter.emitterName,
                emittedStartDate: this.filter.emittedStartDate,
                emittedUntilDate: this.filter.emittedUntilDate,
            }
        },

        getParamFromQuery (paramName) {
            const param =  this.$route.query[paramName];
            return Array.isArray(param) ? param[0] : param;
        }
    },

    mounted() {
        this.getFilterFromUrlQuery();
    },

    watch: {
        emittedStartDateCalendar: function(date) {
            if (date !== '') {
                this.filterEmittedStartDate = this.formatDate(date);
            }
        },
        emittedUntilDateCalendar: function(date) {
            if (date !== '') {
                this.filterEmittedUntilDate = this.formatDate(date);
            }
        },
    },
}
</script>

<style scoped>
.report-body {
    background: #f0f0f0;
    max-width: 100%;
    min-height: 100vh;
}

.filter-btn {
    color: #FFF;
}

.filter-label {
    font-size: 18px;
    color: #333;
}
</style>
